import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { LoggerModule } from 'ngx-logger';
import { environment } from '@environment/environment';
import { routes } from './app.routes';
import { authInterceptors, provideAppAuth } from './auth/provide-app-auth';
import { handleNavigationError } from './navigation-error-handler';
import { provideAppNgxMask } from './ngx-mask.config';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withNavigationErrorHandler(handleNavigationError)),
    provideHttpClient(withInterceptors(authInterceptors)),
    provideAppAuth(),
    importProvidersFrom(LoggerModule.forRoot({ level: environment.logLevel })),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideAppNgxMask(),
  ],
};
